import dynamic from "next/dynamic";

import {
  accountTypeSchemaGe,
  contactInfoSchemaCompanyGe,
  passwordSchemaGe,
} from "@/validations/registration/registrationStepsGe.validation";
import { RegistrationCompanyStepGe } from "@/enums/registrationSteps.enum";
import { companyInfoSchemaGe } from "@/validations/registration/registration.validation";

const AccountTypeComponent = dynamic(
  () => import("@/components/auth/registration/form-components/account-type"),
  { ssr: false },
);
const ContactInfo = dynamic(
  () => import("@/components/auth/registration/form-components/contact-info"),
  { ssr: false },
);
const Password = dynamic(
  () => import("@/components/auth/registration/form-components/password"),
  { ssr: false },
);
const CompanyInfo = dynamic(
  () => import("@/components/auth/registration/form-components/company-info"),
  { ssr: false },
);

export const companyStepsGe = {
  [RegistrationCompanyStepGe.ACCOUNTTYPE]: {
    stepName: "type_of_account",
    component: <AccountTypeComponent />,
    validationSchema: accountTypeSchemaGe,
  },
  [RegistrationCompanyStepGe.CONTACTINFO]: {
    stepName: "registration_contact_information",
    component: <ContactInfo />,
    validationSchema: contactInfoSchemaCompanyGe,
  },
  [RegistrationCompanyStepGe.PASSWORD]: {
    stepName: "password",
    component: <Password />,
    validationSchema: passwordSchemaGe,
  },
  [RegistrationCompanyStepGe.COMPANYINFO]: {
    stepName: "company_information",
    component: <CompanyInfo />,
    validationSchema: companyInfoSchemaGe,
    needsToken: true,
  },
};
